import { ContractReviewFinding } from '../../../models/Entities/Contracts/ContractReview';
import { ContractReviewState, ContractReviewUnloadState } from '../../states/ContractReview.States';
import * as actions from '../../actions/ContractReview.Actions';
import { updateFindings } from './ContractReview.Shared';

const withoutKey = <T,>(record: Record<number, T>, key: number): Record<number, T> => {
  const { [key]: _removed, ...rest } = record;
  return rest;
};

/**
 * Decisiones: la individual es optimista (el REQUEST la aplica y la FAILURE restaura la anterior); la de bloque es
 * todo o nada (DEC-004): sólo la SUCCESS cambia hallazgos.
 */
export default function ContractReviewDecisionReducer(state: ContractReviewState | undefined, action: any): ContractReviewState {
  const current = state ?? ContractReviewUnloadState;
  switch (action.type) {
    case actions.CONTRACT_REVIEW_DECISION_REQUEST:
      return {
        ...current,
        decidingFindingIds: [...current.decidingFindingIds.filter(id => id !== action.findingId), action.findingId],
        decisionErrors: withoutKey(current.decisionErrors, action.findingId),
        byId: updateFindings(current.byId, action.reviewId, f =>
          f.id === action.findingId ? { ...f, decision: action.decision, decisionComment: action.comment } : f
        )
      };
    case actions.CONTRACT_REVIEW_DECISION_SUCCESS:
      return {
        ...current,
        decidingFindingIds: current.decidingFindingIds.filter(id => id !== action.findingId),
        byId: action.finding
          ? updateFindings(current.byId, action.reviewId, f => (f.id === action.findingId ? { ...f, ...action.finding } : f))
          : current.byId
      };
    case actions.CONTRACT_REVIEW_DECISION_FAILURE:
      return {
        ...current,
        decidingFindingIds: current.decidingFindingIds.filter(id => id !== action.findingId),
        decisionErrors: { ...current.decisionErrors, [action.findingId]: action.error },
        byId: updateFindings(current.byId, action.reviewId, f =>
          f.id === action.findingId ? { ...f, decision: action.previousDecision, decisionComment: action.previousComment } : f
        )
      };
    case actions.CONTRACT_REVIEW_DECISION_BULK_REQUEST:
      return { ...current, isBulkDeciding: true, bulkError: undefined };
    case actions.CONTRACT_REVIEW_DECISION_BULK_SUCCESS: {
      const updated = new Map<number, ContractReviewFinding>((action.findings ?? []).map((f: ContractReviewFinding) => [f.id, f]));
      return {
        ...current,
        isBulkDeciding: false,
        bulkError: undefined,
        byId: updateFindings(current.byId, action.reviewId, f => (updated.has(f.id) ? { ...f, ...updated.get(f.id) } : f))
      };
    }
    case actions.CONTRACT_REVIEW_DECISION_BULK_FAILURE:
      return { ...current, isBulkDeciding: false, bulkError: action.error };
    default:
      return current;
  }
}
